// 简易 HTML 清洗，供 v-html 渲染新闻正文前调用。
// 内容由后台管理员维护，威胁模型有限，这里用浏览器原生 DOMParser 做基础过滤：
// 去掉可执行/可嵌入的危险标签，以及 on* 事件属性和 javascript: 链接。
const FORBIDDEN_TAGS = ['script', 'iframe', 'object', 'embed', 'link', 'meta', 'style', 'base', 'form']
const URL_ATTRS = ['href', 'src', 'xlink:href']

export function sanitizeHtml(html: string): string {
  if (!html) return ''

  const doc = new DOMParser().parseFromString(html, 'text/html')

  FORBIDDEN_TAGS.forEach(tag => {
    doc.querySelectorAll(tag).forEach(el => el.remove())
  })

  doc.querySelectorAll('*').forEach(el => {
    Array.from(el.attributes).forEach(attr => {
      const name = attr.name.toLowerCase()
      const value = attr.value || ''
      if (name.startsWith('on') || (URL_ATTRS.includes(name) && /^\s*javascript:/i.test(value))) {
        el.removeAttribute(attr.name)
      }
    })
  })

  return doc.body.innerHTML
}
